import type { JSX } from "react";

import { TextTestID } from "@/constants/TestID";
import { NavigationIconButton, Text } from "@/ui/core";
import { HStack } from "@/ui/layout";
import { joinTestIDs } from "@/utils/string.util";

interface BottomSheetTitleHeaderProps extends ViewWithTestID {
  dismissAccessibilityLabel?: string;
  icon?: JSX.Element;
  onDismiss: () => void;
  title: string;
}

const BottomSheetTitleHeader = ({
  dismissAccessibilityLabel,
  icon,
  onDismiss,
  testID,
  title,
}: BottomSheetTitleHeaderProps) => {
  return (
    <HStack gap={12} justifyContent="space-between">
      <HStack alignItems="center" flexDirection="row" gap={8}>
        {icon}
        <Text testID={joinTestIDs(testID, TextTestID.Title)} variant="h5">
          {title}
        </Text>
      </HStack>
      <NavigationIconButton
        accessibilityLabel={dismissAccessibilityLabel || "Dismiss Alert"}
        onPress={onDismiss}
        testID={joinTestIDs(testID, "dismiss")}
        type="close"
      />
    </HStack>
  );
};

export default BottomSheetTitleHeader;
